import React from "react";

type AttemptsProps = {
  attempts: number;
};

function Attempts({ attempts }: AttemptsProps) {
  return (
    <div className='dark:bg-purple-dark-default flex gap-x-1 rounded-xl bg-purple px-2 py-1'>
      <img src='/static/img/recap/star.svg' alt='star' width='24' height='24' />
      <span className='text-white'>{attempts}</span>
    </div>
  );
}

export default Attempts;
